<template>
  <tr class="invoice">
    <td class="invoice_number">{{ invoice.invoiceNumber }}</td>
    <td class="invoice_date">{{ invoice.date | dateFormat }}</td>
    <td class="invoice_type">{{ invoice.invoiceType | invoiceType }}</td>
    <td class="invoice_amount">{{ invoice.totalAmount | currency }}</td>
    <td v-if="isInvoiceDocumentAvailable(invoice, 'INVOICE', 'pdf')" class="invoice_pdf">
      <a
        :title="this.$t('invoice.export-pdf')"
        class="icon pdf"
        @click="downloadInvoiceDocument(invoice, 'INVOICE', 'pdf')"
      >PDF</a>
    </td>
  </tr>
</template>

<script>

import customFilters from '../../filters'
import invoiceDocumentGroupListItem from '../../mixins/invoice-document-group-list-item'

export default {
  name: 'InvoiceListItem',
  mixins: [invoiceDocumentGroupListItem],
  data () {
    return {
      filters: {
        dateFormat: customFilters.dateFormat,
        invoiceType: customFilters.invoiceType,
        currency: customFilters.currency
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/invoices/InvoiceListItem.vue